import React from 'react';
import {View} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';

import {styles} from '../styles/VolPerUserCardLoading.style';

export const VolPerUserCardLoading: React.FC = () => {
  return (
    <View
      style={styles.card}
      testID="vol-perf-user-card-loading"
      importantForAccessibility="no-hide-descendants"
      accessibilityElementsHidden={true}>
      <View style={styles.container}>
        {/* Header Section */}
        <View style={styles.header}>
          <View style={styles.userInfo}>
            <LoadingBox style={styles.loadingName} testID={''} />
            <LoadingBox style={styles.loadingRole} testID={''} />
          </View>
          <View style={styles.headerRight}>
            <LoadingBox style={styles.loadingOrderType} testID={''} />
            <LoadingBox style={styles.loadingBadge} testID={''} />
          </View>
        </View>

        {/* Order Details Section */}
        <View style={styles.detailsRow}>
          <View style={styles.datesContainer}>
            <LoadingBox style={styles.loadingDetailText} testID={''} />
            <LoadingBox style={styles.loadingDetailText} testID={''} />
          </View>
          <LoadingBox style={styles.loadingOrderNumber} testID={''} />
        </View>

        {/* Stats and Totals Section */}
        <View style={styles.statsContainer}>
          <View style={styles.statItem}>
            <LoadingBox style={styles.loadingStatLabel} testID={''} />
            <LoadingBox style={styles.loadingStatValue} testID={''} />
          </View>
          <View style={styles.statItem}>
            <LoadingBox style={styles.loadingStatLabel} testID={''} />
            <LoadingBox style={styles.loadingStatValue} testID={''} />
          </View>
          <View style={styles.totalContainer}>
            <LoadingBox style={styles.loadingTotalLabel} testID={''} />
            <LoadingBox style={styles.loadingTotalValue} testID={''} />
          </View>
        </View>
      </View>
    </View>
  );
};

export default VolPerUserCardLoading;
